<template>
  <div
    style="padding-left: 3%; padding-right: 3%; background-color: #F8F9FA; min-height: 100vh; height: 100%;"
  >
    <!-- <Title /> -->
    <OverlayLoading :loading="loading" />
    <v-row class="d-flex align-center ma-0 pt-2">
      <img
        width="10"
        height="14"
        src="@/assets/icons/back.png"
        class="mt-0 ml-0"
        style="cursor: pointer;"
        @click="goBack()"
      />
      <span class="header-title ml-0">
        แก้ไขข้อมูลพนักงาน
      </span>
      <v-spacer />
      <div class="mr-4 action-top-btn">
        <v-btn
          width="100"
          class="button-color-outline ma-0 mr-2"
          outlined
          dark
          @click="cancel()"
          >ยกเลิก</v-btn
        >
        <v-btn
          width="100"
          class="ma-0 ml-2"
          color="#2BA197"
          :dark="valid"
          :disabled="!valid"
          @click="checkSubmit()"
          >บันทึกข้อมูล</v-btn
        >
      </div>
    </v-row>
    <!-- ข้อมูลพนักงาน -->
    <v-row
      class="mt-2 rounded-lg"
      justify="center"
      fixed
      centered
      style="background-color: #fff;"
    >
      <v-expansion-panels
        accordion
        v-model="panel"
        multiple
        style="z-index: 0;"
      >
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" style="border-radius: 24px;">
              <v-card-title
                class="text-head-back ra-head-text-bold"
                style="font-size: 16px;"
              >
                ข้อมูลพนักงาน
                <v-spacer></v-spacer>
                <div v-if="editProfile === true">
                  <!-- <v-btn
                    class="button-color-outline ma-0 mr-2"
                    outlined
                    dark
                    @click="editProfile = false"
                    >ยกเลิก</v-btn
                  >
                  <v-btn
                    class="ma-0 ml-2"
                    color="#2BA197"
                    :dark="valid"
                    :disabled="!valid"
                    @click="checkSubmit()"
                    >บันทึกการแก้ไข</v-btn
                  > -->
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        @click="saveEditProfile()"
                      ><template v-slot>
                        <v-icon color="success" size="24px">mdi-content-save-edit</v-icon>
                        </template>
                      </v-btn>
                      </template>
                      <span class="label-table-action"
                        >บันทึกการแก้ไข</span
                      >
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        @click="closeEditProfile()"
                      ><template v-slot>
                        <v-icon size="24px">mdi-close</v-icon>
                        </template>
                      </v-btn>
                      </template>
                      <span class="label-table-action"
                        >ยกเลิกแก้ไข</span
                      >
                    </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        tile
                        class="mr-0"
                        @click="syncEditProfile()"
                      >
                        <template v-slot>
                          <v-icon dark color="success" size="19px"
                            >mdi-autorenew</v-icon
                          >
                        </template>
                      </v-btn>
                    </template>
                    <span class="label-table-action">อัปเดตข้อมูล</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        tile
                        class="mr-0"
                        @click="changeProfile()"
                      >
                        <template v-slot>
                          <v-icon dark color="success" size="19px"
                            >mdi-pencil-outline</v-icon
                          >
                        </template>
                      </v-btn>
                    </template>
                    <span class="label-table-action">แก้ไขข้อมูล</span>
                  </v-tooltip>
                </div>
              </v-card-title>
              <v-card-subtitle>
                <v-row no-gutters class="mt-3">
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    lg="4"
                    class="d-flex flex-column align-center justify-center mt-5 mb-5"
                  >
                        <div
                         v-if="editProfile === false"
                          class="box-employeeimg ml-0"
                          style="max-height: 100%; max-width: 75%; background-size: contain; cursor: default;"
                        >
                          <div class="pa-0 box-placeholderimg">
                            <div
                              class="placeholderimg"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <v-img
                                v-if="!imageUrl"
                                width="100"
                                height="100"
                                contain
                                :src="require('@/assets/icons/no_user.png')"
                                aspect-ratio="1"
                              />
                            </div>
                          </div>
                        </div>
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="box-employeeimg ml-0"
                          @click="ChooseBanner()"
                          style="max-height: 100%; max-width: 75%; background-size: contain;"
                        >
                          <div class="pa-0 box-placeholderimg">
                            <div
                              class="placeholderimg"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <v-img
                                v-if="!imageUrl"
                                width="100"
                                height="100"
                                contain
                                :src="require('@/assets/icons/no_user.png')"
                                aspect-ratio="1"
                              />
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                :disabled="!valid"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                      <span class="" v-if="imageUrl && valid === true"
                        >คลิกเพื่อเลือกรูปใหม่</span
                      >
                      <span class="" v-if="!imageUrl">คลิกเพื่อเลือกรูป</span>
                    </v-tooltip>
                    <span class="label-codeid txt-font mt-5"
                      >รูปภาพประจำตัว</span
                    >
                  </v-col>
                  <v-col cols="12" sm="8" md="8" lg="8" class="mt-5">
                   <v-form ref="editProfileForm">
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">ชื่อ-นามสกุล (ภาษาไทย)</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ fnameTH || "-"
                          }}</span>
                          <v-text-field v-else v-model="editfnameTH" outlined placeholder="ระบุชื่อ-นามสกุล(ภาษาไทย)" dense>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">ชื่อ-นามสกุล (ภาษาอังกฤษ)</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ fnameEN || "-"
                          }}</span>
                          <v-text-field v-else v-model="editfnameEN" outlined placeholder="ระบุชื่อ-นามสกุล(ภาษาอังกฤษ)" dense>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">ชื่อเล่น (ภาษาไทย)</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ nickName || "-"
                          }}</span>
                          <v-text-field v-else v-model="editnickNameTH" outlined placeholder="ระบุชื่อเล่น(ภาษาไทย)" dense>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">ชื่อเล่น (ภาษาอังกฤษ)</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ nickNameEn || "-"
                          }}</span>
                          <v-text-field v-else v-model="editnickNameEN" outlined placeholder="ระบุชื่อเล่น(ภาษาอังกฤษ)" dense>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">วันเกิด</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ birthDate || "-"
                          }}</span>
                          <v-menu v-else v-model="menuedit" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="selectbirthDate" placeholder="เลือกวันเกิด" persistent-hint
                                readonly v-on="on" outlined dense>
                                <template v-slot:append>
                                  <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="selectbirthDate" no-title @input="menuedit = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">อีเมล</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ email || "-"
                          }}</span>
                          <v-text-field v-else v-model="editemail" outlined placeholder="ระบุอีเมล" dense :rules="[
                            // v => !!v || 'กรุณากรอกข้อมูล',
                            v =>
                            !v || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'กรุณากรอกรูปแบบอีเมลให้ถูกต้อง'
                          ]">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">เบอร์โทรศัพท์</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ tel || "-"
                          }}</span>
                          <v-text-field v-else v-model="edittel" outlined placeholder="ระบุเบอร์โทรศัพท์" dense
                            maxlength="10" :rules="[
                              v =>
                                !v || (v.length >= 10) ||
                                'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
                              v =>
                                !v || !/[ ]/.test(v) ||
                                'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                              v => {
                                if (!v) return true;
                                if (v && /^[0-9 ]+$/.test(v)) return true;
                                else
                                return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                              }
                            ]">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">Account ID</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ accountId || "-"
                          }}</span>
                          <v-text-field v-else v-model="accountId" outlined dense disabled background-color="#F5F5F5">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">เบอร์โทรศัพท์บริษัท</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ telcompany || "-"
                          }}</span>
                          <v-text-field v-else v-model="edittelcompany" outlined placeholder="ระบุเบอร์โทรศัพท์บริษัท"
                            dense maxlength="10" :rules="[
                              v =>
                                !v || (v.length >= 10) ||
                                'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
                              v =>
                                !v || !/[ ]/.test(v) ||
                                'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                              v => {
                                if (!v) return true;
                                if (v && /^[0-9 ]+$/.test(v)) return true;
                                else
                                return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                              }
                            ]">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <p class="txt-font">อีเมลบริษัท</p>
                          <span v-if="editProfile === false" class="txt-font" style="color: #333;">{{ emailcompany ||
                            "-" }}</span>
                          <v-text-field v-else v-model="editemailcompany" outlined placeholder="ระบุอีเมลบริษัท" dense
                            :rules="[
                              // v => !!v || 'กรุณากรอกข้อมูล',
                              v => !v || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'กรุณากรอกรูปแบบอีเมลให้ถูกต้อง'
                            ]">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
            <v-divider class="ml-5 mr-5"></v-divider>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0" style="border-radius: 24px;">
              <v-card-title
                class="text-head-back ra-head-text-bold"
                style="font-size: 16px;"
                >ข้อมูลพนักงาน<span class="txt-head"
                  ><span class="ml-1"></span
                  ><span class="txt-font" style="color: grey; font-size: 14px;"
                    >(&nbsp;</span
                  ><span style="color: red;">*</span
                  ><span class="txt-font" style="color: grey; font-size: 14px;">
                    กรอกข้อมูลให้ครบถ้วน)</span
                  ></span
                >
              </v-card-title>
              <v-card-subtitle>
                <v-tabs v-model="tab" class="mt-3">
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab v-for="item in items" :key="item">
                    <span class="txt-font">{{ item }}</span>
                  </v-tab>
                  <v-row v-if="tab === 0">
                    <v-col
                      cols="12"
                      class="pt-0 d-flex flex-row align-center justify-end"
                    >
                      <v-btn
                        outlined
                        color="#fff"
                        :dark="valid"
                        :disabled="!valid"
                        class=""
                        v-scroll-to="{ el: '#element', duration: 1500 }"
                        @click="addEmployee()"
                      >
                        <v-icon left dark class="icon-eye-color" size="14px"
                          >fa-plus</v-icon
                        >
                        <span
                          class="text-sub-color ra-text-in-button-employee"
                          style="font-weight: 600;"
                        >
                          เพิ่มข้อมูลพนักงาน
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <div class="my-2">
                        <div>
                          <!-- {{dataEmployee}} -->
                          <v-card
                            elevation="0"
                            class="mx-auto px-3 mb-5"
                            style="border: 2px solid #EEEEEE;"
                            v-for="(item, i) in dataEmployee"
                            :key="i"
                            :id="
                              i + 1 === dataEmployee.length
                                ? 'element'
                                : undefined
                            "
                          >
                            <div>
                              <v-row style="background-color:#EFF4FD">
                                <v-col cols="10">
                                  <v-col
                                    cols="10"
                                    class="pt-0 pa-2 d-flex flex-row justify-start"
                                  >
                                    <span class="txt-head"
                                      >ลำดับที่ {{ i + 1
                                      }}<span class="ml-1"></span
                                      ><span
                                        class="txt-font"
                                        style="color: grey; font-size: 14px;"
                                        >&nbsp;(</span
                                      ><span style="color: red;">*</span
                                      ><span
                                        class="txt-font"
                                        style="color: grey; font-size: 14px;"
                                        >กรอกข้อมูลให้ครบถ้วน)</span
                                      ></span
                                    >
                                  </v-col>
                                </v-col>
                                <v-col
                                  cols="2"
                                  class="pt-0 pa-0 d-flex flex-row align-center justify-end"
                                >
                                  <v-row
                                    v-show="
                                      item.reqStatus === true &&
                                        item.resignReal === false
                                    "
                                  >
                                    <v-col cols="">
                                      <v-chip
                                        class="mr-1"
                                        color="#FEF5E9"
                                        text-color="#E9A016"
                                      >
                                        <span
                                          >ใบร้องขอกำลังอยู่ระหว่างดำเนินการ</span
                                        >
                                      </v-chip>
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    v-show="
                                      item.reqStatus === false &&
                                        item.resignReal === true
                                    "
                                    class="mt-n2"
                                  >
                                    <v-col cols="">
                                      <v-chip
                                        class="mr-1"
                                        color="#FBE5E4"
                                        text-color="#D1392B"
                                      >
                                        <span>พนักงานได้ทำการลาออกแล้ว</span>
                                      </v-chip>
                                    </v-col>
                                  </v-row>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        :dark="valid"
                                        :disabled="!valid"
                                        icon
                                        tile
                                        class="ra-border-button mr-2"
                                        @click="checkRemoveEmployee(item)"
                                      >
                                        <template v-slot>
                                          <v-icon
                                            dark
                                            color="#D1392B"
                                            size="19px"
                                            >mdi-delete-outline</v-icon
                                          >
                                        </template>
                                      </v-btn>
                                    </template>
                                    <span class="label-table-action"
                                      >ลบข้อมูล</span
                                    >
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                              <v-row class="pa-5">
                                <v-col cols="12">
                                  <span class="txt-head">ประเภทพนักงาน</span>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" lg="4">
                                  <v-radio-group
                                    v-model="dataEmployee[i].typeText"
                                    row
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                  >
                                    <v-row>
                                      <v-col cols="6">
                                        <v-radio
                                          class="mb-2"
                                          color="#2BA197"
                                          label="พนักงานภายใน"
                                          value="พนักงานภายใน"
                                        ></v-radio>
                                        <v-radio
                                          color="#2BA197"
                                          label="ที่ปรึกษา"
                                          value="ที่ปรึกษา"
                                        ></v-radio>
                                      </v-col>
                                      <v-col cols="6">
                                        <v-radio
                                          class="mb-2"
                                          color="#2BA197"
                                          label="พนักงานภายนอก"
                                          value="พนักงานภายนอก"
                                        ></v-radio>
                                        <v-radio
                                          color="#2BA197"
                                          label="นักศึกษาฝึกงาน"
                                          value="นักศึกษาฝึกงาน"
                                        ></v-radio>
                                      </v-col>
                                    </v-row>
                                  </v-radio-group>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                  lg="4"
                                  class="mt-n5"
                                >
                                  <span>ต้นสังกัด</span
                                  ><span style="color: red;"> *</span>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].parentCompanyText"
                                    :items="['บริษัทหลัก', 'บริษัทรอง']"
                                    placeholder="เลือกต้นสังกัด"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    @change="
                                      setparentCompany(
                                        i,
                                        dataEmployee[i].parentCompanyText
                                      )
                                    "
                                    outlined
                                    :rules="rulesCompany"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                  lg="4"
                                  class="mt-n5"
                                >
                                  <span>ศูนย์</span>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].station"
                                    :items="stationList"
                                    item-text="stationName"
                                    item-value="stationName"
                                    placeholder="เลือกศูนย์"
                                    outlined
                                    :rules="rulesStation"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row class="pl-5 pr-5 mt-n6">
                                <v-col cols="12">
                                  <span class="txt-head"
                                    >ระดับความน่าเชื่อถือ</span
                                  >
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="d-flex"
                                  style="justify-content: center; align-items: center;"
                                >
                                  <v-progress-linear
                                    :value="level_bar[i]"
                                    color="#4CAF50"
                                    height="25"
                                  >
                                    <template v-slot:default="{ value }">
                                      <!-- พนักงานภายใน -->
                                      <strong
                                        v-if="
                                          value == 30 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายใน'
                                        "
                                        style="color: white"
                                        >LV. 1</strong
                                      >
                                      <strong
                                        v-if="
                                          value == 60 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายใน'
                                        "
                                        style="color: white"
                                        >LV. 2</strong
                                      >
                                      <strong
                                        v-if="
                                          value == 70 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายใน'
                                        "
                                        style="color: white"
                                        >LV. 2</strong
                                      >
                                      <strong
                                        v-if="
                                          value == 100 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายใน'
                                        "
                                        style="color: white"
                                        >LV. 3</strong
                                      >
                                      <!-- พนักงานภายนอก -->
                                      <strong
                                        v-if="
                                          value == 50 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายนอก'
                                        "
                                        style="color: white"
                                        >LV. 1</strong
                                      >
                                      <strong
                                        v-if="
                                          value == 100 &&
                                            dataEmployee[i].typeText ==
                                              'พนักงานภายนอก'
                                        "
                                        style="color: white"
                                        >LV. 2</strong
                                      >
                                      <span class="progress-bar-txt">
                                        {{ value }}%
                                      </span>
                                    </template>
                                  </v-progress-linear>
                                </v-col>
                                <v-col cols="12" class="ml-n3">
                                  <!-- <v-icon
                                    v-if="dataEmployee[i].typeText == ''"
                                    icon
                                    class="text-right"
                                    color="grey"
                                    >mdi-checkbox-marked-circle</v-icon
                                  >
                                  <span
                                    v-if="dataEmployee[i].typeText == ''"
                                    class="ml-1 mr-6"
                                    >รหัสพนักงาน
                                  </span> -->
                                  <v-icon
                                    icon
                                    class="text-right ml-6"
                                    :color="
                                      dataEmployee[i].employeeId !== ''
                                        ? 'green'
                                        : 'grey'
                                    "
                                    >mdi-checkbox-marked-circle</v-icon
                                  >
                                  <span class="ml-1 mr-6">รหัสพนักงาน </span>
                                  <!-- <v-icon
                                    icon
                                    class="text-right"
                                    :color="
                                      dataEmployee[i].lineofworkId !== '' &&
                                      dataEmployee[i].lineofworkId !== 'ไม่มี'
                                        ? 'green'
                                        : 'grey'
                                    "
                                  >
                                    mdi-checkbox-marked-circle</v-icon
                                  > -->
                                  <v-icon
                                    icon
                                    class="text-right"
                                    :color="
                                      dataEmployee[i].orgchart !== '' &&
                                      dataEmployee[i].orgchart !== 'ไม่มี'
                                        ? 'green'
                                        : 'grey'
                                    "
                                  >
                                    mdi-checkbox-marked-circle</v-icon
                                  >
                                  <span class="ml-1">แผนก</span>
                                  <v-icon
                                    icon
                                    class="text-right ml-6"
                                    :color="
                                      dataEmployee[i].positionId == '' ||
                                      dataEmployee[i].positionId == null ||
                                      dataEmployee[i].positionId == 'ไม่มี'
                                        ? 'grey'
                                        : 'green'
                                    "
                                    >mdi-checkbox-marked-circle</v-icon
                                  >
                                  <span class="ml-1">ตำแหน่งงาน</span>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="dataEmployee[i].typeText !== ''"
                                class="mx-3"
                                style="margin-bottom: -5px;"
                              >
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <span>บริษัท</span
                                  ><span style="color: red;"> *</span>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].companyId"
                                    :items="dataEmployee[i].companyItems"
                                    placeholder="เลือกบริษัท"
                                    item-text="companyFullNameTh"
                                    item-value="_id"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    @change="
                                      getSelectLineofworkDetail(
                                        i,
                                        dataEmployee[i].companyId,
                                        ''
                                      ),
                                        manage_linear(i)
                                    "
                                    @keyup="
                                      getSelectCompany(i, $event.target.value)
                                    "
                                    outlined
                                    :rules="rulesCompany"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <span>รหัสพนักงาน</span
                                  ><span style="color: red;"> *</span>
                                  <v-text-field
                                    v-model="dataEmployee[i].employeeId"
                                    :rules="dataEmployee[i].rulesEmployeeId"
                                    dense
                                    outlined
                                    :readonly="dataEmployee[i].companyId === ''"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    placeholder="ระบุรหัสพนักงาน"
                                    @input="manage_linear(i)"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <span>รูปแบบพนักงาน</span>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].contractType"
                                    :items="employeeTypeList"
                                    item-text="type"
                                    item-value="type"
                                    placeholder="เลือกรูปแบบพนักงาน"
                                    outlined
                                    :readonly="dataEmployee[i].companyId === ''"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                  >
                                    <template v-slot:selection="{ item }">
                                      {{ item.type }}
                                    </template>
                                    <template v-slot:item="{ item }">
                                      {{`${item.type} (${item.typeEng})`,}}
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <span>วันที่เริ่มงาน</span
                                  ><span style="color: red;"> *</span>
                                  <v-menu
                                    v-model="dataEmployee[i].menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="dataEmployee[i].startWorkDate"
                                        placeholder="เลือกวันที่เริ่มทำงาน"
                                        persistent-hint
                                        readonly
                                        v-on="on"
                                        outlined
                                        dense
                                        :disabled="
                                          dataEmployee[i].reqStatus === true ||
                                            dataEmployee[i].resignReal == true
                                        "
                                      >
                                        <template v-slot:append>
                                          <v-icon class="icon-eye-color"
                                            >mdi-calendar</v-icon
                                          >
                                        </template>
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="dataEmployee[i].startWorkDate"
                                      no-title
                                      @input="dataEmployee[i].menu = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                  lg="4"
                                  v-if="
                                    dataEmployee[i].typeText === 'พนักงานภายนอก'
                                  "
                                >
                                  <span>วันที่สิ้นสุด(ไม่จำเป็น)</span>
                                  <v-menu
                                    v-model="dataEmployee[i].menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="dataEmployee[i].endWorkDate"
                                        placeholder="เลือกวันที่สิ้นสุด"
                                        persistent-hint
                                        readonly
                                        v-on="on"
                                        outlined
                                        dense
                                        :disabled="
                                          dataEmployee[i].reqStatus === true ||
                                            dataEmployee[i].resignReal == true
                                        "
                                      >
                                        <template v-slot:append>
                                          <v-icon class="icon-eye-color"
                                            >mdi-calendar</v-icon
                                          >
                                        </template>
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="dataEmployee[i].endWorkDate"
                                      no-title
                                      @input="dataEmployee[i].menu2 = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <!-- รวมแผนก -->
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <span>แผนก</span>
                                  <span style="color: red;"> *</span>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].orgchart"
                                    :items="dataEmployee[i].departmentItems"
                                    placeholder="เลือกแผนก"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].companyId === '' ||
                                        dataEmployee[i].reqStatus === true ||
                                          dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesLineofworks"
                                    @keyup="
                                      getSelect(
                                        $event.target.value,
                                        'แผนก',
                                        i,
                                        dataEmployee[i].companyId
                                      )
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <!-- สายงาน -->
                                <!-- <v-col cols="12" sm="6" md="4" lg="4" >
                                  <span>สายงาน</span
                                  ><span
                                    v-if="
                                      dataEmployee[i].lineofworkStatus === true
                                    "
                                    style="color: red;"
                                  >
                                    *</span
                                  >
                                  <v-select
                                    dense
                                    v-model="dataEmployee[i].lineofworkId"
                                    :items="dataEmployee[i].lineofworkItems"
                                    placeholder="เลือกสายงาน"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].lineofworkStatus ===
                                        false ||
                                        dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesLineofworks"
                                    @change="
                                      getDataListOrgChart(
                                        i,
                                        dataEmployee[i].lineofworkId,
                                        dataEmployee[i].companyId,
                                        'สายงาน'
                                      )
                                    "
                                    @input="manage_linear(i)"
                                  ></v-select>
                                </v-col> -->
                                <!-- ฝ่ายงาน -->
                                <!-- <v-col cols="12" sm="6" md="4" lg="4" >
                                  <span>ฝ่ายงาน</span
                                  ><span
                                    v-if="
                                      dataEmployee[i].departmentStatus === true
                                    "
                                    style="color: red;"
                                  >
                                    *</span
                                  >
                                  <v-select
                                    dense
                                    v-model="dataEmployee[i].departmentId"
                                    :items="dataEmployee[i].departmentItems"
                                    placeholder="เลือกฝ่ายงาน"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].departmentStatus ===
                                        false ||
                                        dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesDepartment"
                                    @change="
                                      getDataListOrgChart(
                                        i,
                                        dataEmployee[i].departmentId,
                                        dataEmployee[i].companyId,
                                        'ฝ่ายงาน'
                                      )
                                    "
                                  ></v-select>
                                </v-col> -->
                                <!-- ส่วนงาน -->
                                <!-- <v-col cols="12" sm="6" md="4" lg="4" >
                                  <span>ส่วนงาน</span
                                  ><span
                                    v-if="
                                      dataEmployee[i].sectionStatus === true
                                    "
                                    style="color: red;"
                                  >
                                    *</span
                                  >
                                  <v-select
                                    dense
                                    v-model="dataEmployee[i].sectionId"
                                    :items="dataEmployee[i].sectionItems"
                                    placeholder="เลือกส่วนงาน"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].sectionStatus === false ||
                                        dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesSection"
                                    @change="
                                      getDataListOrgChart(
                                        i,
                                        dataEmployee[i].sectionId,
                                        dataEmployee[i].companyId,
                                        'ส่วนงาน'
                                      )
                                    "
                                  ></v-select>
                                </v-col> -->
                                <!-- หน่วยงาน -->
                                <!-- <v-col cols="12" sm="6" md="4" lg="4" >
                                  <span>หน่วยงาน</span
                                  ><span
                                    v-if="dataEmployee[i].agencyStatus === true"
                                    style="color: red;"
                                  >
                                    *</span
                                  >
                                  <v-select
                                    dense
                                    v-model="dataEmployee[i].agencyId"
                                    :items="dataEmployee[i].agencyItems"
                                    placeholder="เลือกหน่วยงาน"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].agencyStatus === false ||
                                        dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesAgency"
                                    @change="
                                      getDataListOrgChart(
                                        i,
                                        dataEmployee[i].agencyId,
                                        dataEmployee[i].companyId,
                                        'หน่วยงาน'
                                      )
                                    "
                                  ></v-select>
                                </v-col> -->
                                <!-- กลุ่มงาน -->
                                <!-- <v-col cols="12" sm="6" md="4" lg="4" >
                                  <span>กลุ่มงาน</span
                                  ><span
                                    v-if="dataEmployee[i].groupStatus === true"
                                    style="color: red;"
                                  >
                                    *</span
                                  >
                                  <v-select
                                    dense
                                    v-model="dataEmployee[i].groupId"
                                    :items="dataEmployee[i].groupItems"
                                    placeholder="เลือกประเภท"
                                    item-text="orgChartName"
                                    item-value="_id"
                                    outlined
                                    :disabled="
                                      dataEmployee[i].groupStatus === false ||
                                        dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    :rules="dataEmployee[i].rulesGroup"
                                    @change="
                                      getDataListOrgChart(
                                        i,
                                        dataEmployee[i].groupId,
                                        dataEmployee[i].companyId,
                                        'กลุ่มงาน'
                                      )
                                    "
                                  ></v-select>
                                </v-col> -->
                                <!-- ตำแหน่งงาน -->
                                <v-col cols="12" sm="6" md="4" lg="4">
                                  <v-row
                                    :style="
                                      $vuetify.breakpoint.name !== 'lg'
                                        ? 'margin-top: -3.8%;'
                                        : 'margin-top: -6.2%;'
                                    "
                                  >
                                    <span class="ml-3 mt-5">ตำแหน่งงาน</span
                                    ><span
                                      class="ml-1 mt-5"
                                      v-if="dataEmployee[i].companyId !== ''"
                                      style="color: red;"
                                    >
                                      *</span
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      outlined
                                      color="#fff"
                                      dark
                                      class="my-2"
                                      style="margin-top: 0%;"
                                      @click="
                                        openDialogAddPosition(
                                          dataEmployee[i].companyId,
                                          i
                                        )
                                      "
                                      :disabled="
                                        dataEmployee[i].reqStatus === true ||
                                          dataEmployee[i].resignReal == true
                                      "
                                    >
                                      <v-icon
                                        left
                                        dark
                                        class="icon-eye-color"
                                        size="14px"
                                        >fa-plus</v-icon
                                      >
                                      <span
                                        class="text-sub-color ra-text-in-button-employee"
                                        style="font-weight: 600;"
                                      >
                                        เพิ่มตำแหน่งงาน
                                      </span>
                                    </v-btn>
                                  </v-row>
                                  <v-autocomplete
                                    dense
                                    v-model="dataEmployee[i].positionId"
                                    :items="dataEmployee[i].positionItems"
                                    placeholder="เลือกตำแหน่ง"
                                    item-text="positionName"
                                    item-value="_id"
                                    outlined
                                    :rules="dataEmployee[i].rulesPosition"
                                    :disabled="
                                      dataEmployee[i].reqStatus === true ||
                                        dataEmployee[i].resignReal == true
                                    "
                                    @input="manage_linear(i)"
                                    @keyup="
                                      getSelect(
                                        $event.target.value,
                                        'ตำแหน่ง',
                                        i,
                                        dataEmployee[i].companyId
                                      )
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  v-if="
                                    dataEmployee[i].typeText === 'พนักงานภายใน'
                                  "
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                >
                                  <div v-if="dataEmployee[i].resign === true" class="manage-department-title">
                                    การลาออกจากบริษัท
                                  </div>
                                </v-col>
                                <v-col
                                  v-if="
                                    dataEmployee[i].typeText === 'พนักงานภายใน'
                                  "
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                >
                                  <div class="d-flex flex-row">
                                    <!-- <span class="txt-font mr-4 mt-2"
                                      >พนักงานต้องการลาออก</span
                                    > -->
                                    <!-- <v-switch
                                      class="mt-0"
                                      v-model="dataEmployee[i].resign"
                                      color="primary"
                                      :disabled="
                                        chkDisable === true ||
                                          dataEmployee[i].reqStatus === true ||
                                          dataEmployee[i].resignReal == true
                                      "
                                    ></v-switch> -->
                                    <!-- <v-divider
                                      v-if="dataEmployee[i].resign === true"
                                      class="ml-5 mt-n2"
                                      vertical
                                      style="height: 40px;"
                                    ></v-divider> -->
                                    <v-col
                                      v-if="dataEmployee[i].resign === true"
                                      cols="3"
                                      sm="3"
                                      md="3"
                                      lg="3"
                                    >
                                      <span class="txt-font"
                                        >วันทำงานวันสุดท้าย</span
                                      ><span
                                        v-if="dataEmployee[i].resign === true"
                                        style="color: red;"
                                      >
                                        *</span
                                      >
                                      <v-menu
                                        v-model="dataEmployee[i].menuResign"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            v-model="
                                              dataEmployee[i].lastWorkDate
                                            "
                                            placeholder="เลือกวันที่สิ้นสุด"
                                            persistent-hint
                                            readonly
                                            v-on="on"
                                            outlined
                                            dense
                                            :disabled="
                                              dataEmployee[i].reqStatus ===
                                                true ||
                                                dataEmployee[i].resignReal ==
                                                  true
                                            "
                                          >
                                            <template v-slot:append>
                                              <img
                                                width="20"
                                                height="20"
                                                src="@/assets/icons/today.png"
                                              />
                                            </template>
                                          </v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="dataEmployee[i].lastWorkDate"
                                          no-title
                                          @input="
                                            dataEmployee[i].menuResign = false
                                          "
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col
                                      v-if="dataEmployee[i].resign === true"
                                      cols="3"
                                      sm="3"
                                      md="3"
                                      lg="3"
                                    >
                                      <span class="txt-font"
                                        >วันลาออกมีผลบังคับใช้เมื่อ</span
                                      ><span
                                        v-if="dataEmployee[i].resign === true"
                                        style="color: red;"
                                      >
                                        *</span
                                      >
                                      <v-menu
                                        v-model="dataEmployee[i].menuResign"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            v-model="
                                              dataEmployee[i].endWorkDate
                                            "
                                            placeholder="เลือกวันที่สิ้นสุด"
                                            persistent-hint
                                            readonly
                                            v-on="on"
                                            outlined
                                            dense
                                            :disabled="
                                              dataEmployee[i].reqStatus ===
                                                true ||
                                                dataEmployee[i].resignReal ==
                                                  true
                                            "
                                          >
                                            <template v-slot:append>
                                              <img
                                                width="20"
                                                height="20"
                                                src="@/assets/icons/today.png"
                                              />
                                            </template>
                                          </v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="dataEmployee[i].endWorkDate"
                                          no-title
                                          @input="
                                            dataEmployee[i].menuResign = false
                                          "
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                  <div class="manage-department-title">
                                    การอนุมัติ
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                  <div class="d-flex flex-row">
                                    <span class="txt-font mr-4 mt-2"
                                      >ต้องการให้หัวหน้าอนุมัติ</span
                                    >
                                    <v-switch
                                      class="mt-0"
                                      v-model="dataEmployee[i].chkLeaderApprove"
                                      color="#2BA197"
                                      :disabled="
                                        chkDisable === true ||
                                          dataEmployee[i].reqStatus === true ||
                                          dataEmployee[i].resignReal == true
                                      "
                                      @change="
                                        setOpenApprover(
                                          i,
                                          dataEmployee[i].chkLeaderApprove
                                        )
                                      "
                                    ></v-switch>
                                    <v-divider
                                      v-if="
                                        dataEmployee[i].chkLeaderApprove ===
                                          true
                                      "
                                      class="ml-5 mt-n2"
                                      style="height: 40px;"
                                      vertical
                                    ></v-divider>
                                    <v-btn
                                      v-if="
                                        dataEmployee[i].chkLeaderApprove ===
                                          true
                                      "
                                      outlined
                                      right
                                      color="#fff"
                                      dark
                                      class="mr-2 ml-3 mb-0 pa-1 align-center mt-n2"
                                      @click="
                                        openDialogAddAprover('add', '', i)
                                      "
                                      :disabled="
                                        dataEmployee[i].reqStatus === true ||
                                          dataEmployee[i].resignReal == true
                                      "
                                    >
                                      <v-icon left dark class="icon-eye-color"
                                        >fa-plus</v-icon
                                      >
                                      <span class="text-sub-color txt-font"
                                        >เพิ่มผู้อนุมัติ/รับทราบ</span
                                      >
                                    </v-btn>
                                  </div>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  v-for="(itemJ, j) in dataEmployee[i].approver"
                                  :key="j"
                                >
                                  <v-expand-transition>
                                    <v-card
                                      v-show="dataEmployee[i].expand"
                                      class="elevation-0 mx-auto px-3"
                                      style="background-color: #FAFAFA; border-radius: 4px; border: 2px solid #EEEEEE;"
                                    >
                                      <v-row style="background-color:#EFF4FD;">
                                        <v-col
                                          cols="10"
                                          class="pt-0 pa-2 d-flex flex-row justify-start"
                                        >
                                          <span
                                            class="ra-text-in-button-employee mt-2"
                                            style="color: #3776E9;"
                                          >
                                            ลำดับที่ {{ j + 1 }}
                                          </span>
                                        </v-col>
                                        <v-col
                                          cols="2"
                                          class="pt-0 pa-2 d-flex flex-row align-center justify-end"
                                        >
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                rounded
                                                small
                                                dark
                                                icon
                                                class="ra-border-button mt-2 mb-0"
                                                @click="
                                                  openDialogAddAprover(
                                                    'edit',
                                                    itemJ,
                                                    i,
                                                    j
                                                  )
                                                "
                                              >
                                                <template v-slot>
                                                  <img
                                                    width="18"
                                                    height="18"
                                                    src="@/assets/icons/edit-icon.png"
                                                  />
                                                </template>
                                              </v-btn>
                                            </template>
                                            <span class="label-table-action"
                                              >จัดการผู้ดูแล</span
                                            >
                                          </v-tooltip>
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ attrs }"
                                            >
                                              <v-btn
                                                v-bind="attrs"
                                                rounded
                                                dark
                                                small
                                                icon
                                                class="ra-border-button mt-2 mb-0 ml-2"
                                                @click="checkRemove(itemJ, i)"
                                              >
                                                <template v-slot>
                                                  <img
                                                    width="18"
                                                    height="18"
                                                    src="@/assets/icons/delete-icon.png"
                                                  />
                                                </template>
                                              </v-btn>
                                            </template>
                                            <span class="label-table-action"
                                              >ลบผู้ดูแล</span
                                            >
                                          </v-tooltip>
                                        </v-col>
                                      </v-row>
                                      <v-row no-gutters class="mt-3">
                                        <v-col cols="1">
                                          <v-avatar
                                            class="mt-3 ml-3"
                                            size="60"
                                            rounded
                                            style="float: left;"
                                          >
                                            <v-img
                                              class="card-header-userimg-border"
                                              cover
                                              :lazy-src="
                                                require('@/assets/icons/no_user.png')
                                              "
                                              :src="
                                                itemJ.failed_image
                                                  ? require('@/assets/icons/no_user.png')
                                                  : itemJ.userImg
                                              "
                                              :alt="itemJ.employeeId"
                                              v-on:error="onImgError(i, j)"
                                              aspect-ratio="1"
                                              height="100%"
                                            />
                                          </v-avatar>
                                        </v-col>
                                        <v-col cols="10" class="ml-8">
                                          <v-row class="mr-3">
                                            <v-col
                                              cols="4"
                                              class="justify-start align-start"
                                            >
                                              <span
                                                class="txt-font"
                                                style="margin-top: 2.5%;"
                                                >รหัสพนักงาน:
                                              </span>
                                              <span
                                                class="txt-font text-left"
                                                style="color: #333; margin-top: 0%;"
                                                >{{ itemJ.employeeId || "-" }}
                                              </span>
                                            </v-col>
                                            <v-col
                                              cols="4"
                                              class="justify-start align-start"
                                            >
                                              <span
                                                class="txt-font"
                                                style="margin-top: 2.5%;"
                                                >ชื่อ-นามสกุล:
                                              </span>
                                              <span
                                                class="txt-font text-left"
                                                style="color: #333; margin-top: 0%;"
                                                >{{
                                                  itemJ.approverName || "-"
                                                }}</span
                                              >
                                            </v-col>
                                            <!-- <v-col
                                              cols="4"
                                              class="justify-start align-start"
                                            >
                                              <span
                                                class="txt-font"
                                                style="margin-top: 2.5%;"
                                                >ตำแหน่งงาน:
                                              </span>
                                              <span
                                                class="txt-font text-left"
                                                style="color: #333; margin-top: 0%;"
                                                >{{ itemJ.position || "-" }}
                                              </span>
                                            </v-col> -->
                                          </v-row>
                                          <v-row class="mr-3">
                                            <v-col
                                              cols="4"
                                              class="justify-start align-start"
                                            >
                                              <span
                                                class="txt-font"
                                                style="margin-top: 2.5%;"
                                                >อีเมล:
                                              </span>
                                              <span
                                                class="txt-font text-left"
                                                style="color: #333; margin-top: 0%;"
                                                >{{ itemJ.email || "-" }}
                                              </span>
                                            </v-col>
                                            <v-col
                                              cols="4"
                                              class="justify-start align-start"
                                            >
                                              <span
                                                class="txt-font"
                                                style="margin-top: 2.5%;"
                                                >สถานะ:
                                              </span>
                                              <span
                                                class="txt-font text-left"
                                                style="color: #333; margin-top: 0%;"
                                                >{{ itemJ.approveType || "-" }}
                                              </span>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-expand-transition>
                                </v-col>
                              </v-row>
                            </div>
                          </v-card>
                        </div>
                      </div>
                    </v-tab-item>
                    <v-tab-item class="txt-font">
                      <div class="my-2 d-flex justify-center align-center" style="overflow-x: auto; max-width: 1182px;">
                        <v-responsive width="100%">
                          <v-data-table :headers="headersHistory" :items="employeeData" :items-per-page="5"
                            class="border-table-employee text-no-wrap mt-1 elevation-0" item-key="no" disable-sort>
                            <template v-slot:[`item.no`]="{ item }">
                              {{ employeeData.indexOf(item) + 1 }}
                            </template>
                            <template v-slot:[`item.createAt`]="{ item }">
                              <v-row>
                                <span>{{
                                  formatDate(item.createAt) || "-"
                                  }}</span>
                              </v-row>
                            </template>
                            <template v-slot:[`item.doctTypeText`]="{ item }">
                              <span>{{ item.doctTypeText || "-" }}</span>
                            </template>
                            <template v-slot:[`item.oldPosition`]="{ item }">
                              <span>{{ item.oldPosition || "-" }}</span>
                            </template>
                            <template v-slot:[`item.newPosition`]="{ item }">
                              <v-row>
                                <span>{{ item.newPosition || "-" }}</span>
                              </v-row>
                              <v-row>
                                <span>{{ item.newOrgChartName }}</span>
                              </v-row>
                            </template>
                            <template v-slot:[`item.oldCompany`]="{ item }">
                              <span>{{ item.oldCompany || "-" }}</span>
                            </template>
                            <template v-slot:[`item.newCompany`]="{ item }">
                              <span>{{ item.newCompany || "-" }}</span>
                            </template>
                          </v-data-table>
                        </v-responsive>
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-expansion-panels>
    </v-row>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title
          class="text-sub-color ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="button-color-outline"
            outlined
            @click="dialogDelete = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="button-color"
            dark
            @click="removeEmployee(itemConfirmDelete)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
      <v-card height="170px">
        <v-card-title
          class="text-sub-color ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้อนุมัติคนนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="button-color-outline"
            outlined
            @click="dialogDeleteApprover = false"
            >ยกเลิก</v-btn
          >
          <v-btn class="button-color" dark @click="removeApprover()"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor"
            >fa-check-circle</v-icon
          >
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
    <DialogAddAprover />
    <DialogAddPosition />
  </div>
</template>

<script>
// import Title from '../_overview/title.vue'
import OverlayLoading from '../../_template/OverlayLoading.vue'
// import FullLoading from '../../_template/FullLoading.vue'
import { EventBus } from '@/EventBus'
// import TableEmployeeLog from './tableEmployeeLog'
import swal from 'sweetalert'
import {
  // hostImageUrl,
  hostImageUrlv3,
  searchSelectEmployee,
  // getSelectCompanyEmployee,
  getSelectCompanyEmployeeNew,
  // getListOrgChart, // ปิดแปป
  // getSelecPositionEmployee,
  editEmployee, // แก้ไขข้อมูลพนักงาน
  // checkOrgChartInCompany, // ปิดแปป
  getDefaultApprover,
  SelectDataCenterinEditOfficer,
  editEmployeeDetail,
  updateUserOneData
} from '@/API/API'
import DialogAddAprover from '../_create/dialogAddApprover'
import DialogAddPosition from '../_create/dialogAddPosition'
import moment from 'moment'
moment.locale('th')

export default {
  components: {
    OverlayLoading,
    // FullLoading,
    DialogAddAprover,
    DialogAddPosition
    // TableEmployeeLog
  },
  name: 'create-new-employee',
  data () {
    return {
      isload: false,
      level_bar: [],
      validContractType: [],
      moods: [
        { name: 'Crying', emoji: '😢' },
        { name: 'Grinning Squinting Face', emoji: '😆' }
      ],
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      dialogDeleteApprover: false,
      titleDialog: '',
      itemConfirmDelete: [],
      employeeData: [],
      itemIdex: 0,
      tab: null,
      items: ['ข้อมูลพนักงาน', 'ประวัติพนักงาน'],
      panel: [0, 0],
      typeText: null,
      activeTab: 1,
      loading: false,
      loadingProfileData: false,
      loadingEmployeeData: false,
      keySearchEmployee: [],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      rulesSearch: [v => !!v || 'กรุณากรอก Username หรือ E-mail'],
      imgUser: null,
      imageUrl: null,
      failed_imageEmployee: false,
      imagePathUrl: null,
      genderth_radios: null,
      genderen_radios: null,
      itemDefault: [
        {
          orgChartName: 'ไม่มี',
          pid: null,
          _id: 'ไม่มี'
        }
      ],
      genderthlists: [
        {
          id: 0,
          nameTH: 'นาย',
          nameEN: 'Mr.',
          value: 'Mr.'
        },
        {
          id: 1,
          nameTH: 'นาง',
          nameEN: 'Mrs.',
          value: 'Mrs.'
        },
        {
          id: 2,
          nameTH: 'นางสาว',
          nameEN: 'Ms.',
          value: 'Miss'
        }
      ],
      fnameTH: '',
      lnameTH: '',
      fnameEN: '',
      lnameEN: '',
      nickName: '',
      nickNameEn: '',
      accountId: '',
      birthDate: moment(new Date().toISOString().substr(0, 10)).format(
        'DD/MM/YYYY'
      ),
      email: '',
      tel: '',
      companyId: '',
      companyItems: [], // รายชื่อบริษัท
      rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
      rulesStation: [v => !!v || 'กรุณาเลือกศูนย์'],
      employeeId: '',
      rulesEmployeeId: [v => !!v || 'กรุณากรอกรหัสพนักงาน'],
      lineofworkId: '',
      lineofworkItems: [],
      rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
      departmentId: '',
      departmentItems: [],
      rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
      positionId: '',
      positionItems: [], // ตำแหน่งงาน
      rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
      // startWorkDate: moment(new Date().toISOString().substr(0, 10)).format('DD/MM/YYYY'),
      startWorkDate: new Date().toISOString().substr(0, 10),
      endWorkDate: new Date().toISOString().substr(0, 10),
      lastWorkDate: new Date().toISOString().substr(0, 10),
      rulesDateStart: [v => !!v || 'กรุณาเลือกวันที่เริ่มงาน'],
      rulesDateEnd: [v => !!v || 'กรุณาเลือกวันที่สิ้นสุด'],
      chkDisable: false,
      stationList: [],
      employeeTypeList: [],
      departmentsItems: [], // รวมแผนก
      dataEmployee: [
        {
          typeText: 1,
          parentCompanyText: '',
          companyId: '',
          expand: false,
          menuResign: false,
          menu: false,
          menu2: false,
          dateResign: new Date().toISOString().substr(0, 10),
          startWorkDate: new Date().toISOString().substr(0, 10),
          endWorkDate: new Date().toISOString().substr(0, 10),
          lastWorkDate: new Date().toISOString().substr(0, 10),
          contractType: '',
          station: '',
          rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
          lineofworkStatus: false,
          lineofworkDisable: false,
          lineofworkId: '',
          lineofworkItems: [],
          rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
          departmentStatus: false,
          departmentDisable: false,
          departmentId: '',
          departmentItems: [],
          rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
          sectionStatus: false,
          sectionDisable: false,
          sectionId: '',
          sectionItems: [],
          rulesSection: [v => !!v || 'กรุณาเลือกส่วนงาน'],
          groupStatus: false,
          groupDisable: false,
          groupId: '',
          groupItems: [],
          rulesGroup: [v => !!v || 'กรุณาเลือกกลุ่มงาน'],
          agencyStatus: false,
          agencyDisable: false,
          agencyId: '',
          agencyItems: [],
          rulesAgency: [v => !!v || 'กรุณาเลือกหน่วยงาน'],
          positionStatus: false,
          positionDisable: true,
          positionId: '',
          positionItems: [],
          companyItems: [],
          rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
          employeeId: '',
          chkLeaderApprove: false,
          leaderApprove: 'ไม่ต้องการ',
          resign: false,
          approver: [],
          orgchart: ''
        }
      ],
      valid: false,
      alertText: {
        'user is already': 'มีข้อมูลผู้ใช้ในระบบแล้ว',
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'chart not found': 'ไม่พบฝ่ายงานที่ต้องการ',
        'user not found': 'ไม่พบผู้ใช้งาน',
        'request is already': 'มีคำร้องนี้ในระบบแล้ว',
        'data incomplete': 'กรุณากรอกข้อมูลให้ครบถ้วน'
      },
      alertTextDetail: {
        'user is already': 'กรุณาลองใหม่อีกครั้ง',
        'employeeId is already': 'กรุณาลองใหม่อีกครั้ง',
        'chart not found': 'กรุณาลองใหม่อีกครั้ง',
        'user not found': 'กรุณาลองใหม่อีกครั้ง',
        'request is already': 'กรุณาอนุมัติคำร้องที่มีอยู่ในระบบ'
      },
      expand: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่งงาน', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersHistory: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ประเภทพนักงาน', value: 'typeText' },
        { text: 'ประเภทรายการ', value: 'doctTypeText' },
        { text: 'รายละเอียดงานเดิม', value: 'oldPosition' },
        { text: 'รายละเอียดงานใหม่', value: 'newPosition' },
        { text: 'บริษัทเดิม', value: 'oldCompany' },
        { text: 'บริษัทใหม่', value: 'newCompany', sortable: false },
        { text: 'วันเวลาทำรายการ', value: 'createAt', sortable: false }
      ],
      // แก้ไข
      editfnameTH: '',
      editfnameEN: '',
      editnickNameTH: '',
      editnickNameEN: '',
      editemail: '',
      edittel: '',
      edittelcompany: '',
      editemailcompany: '',
      telcompany: '',
      emailcompany: '',
      editProfile: false, // แก้ไขข้อมูลพนักงาน
      menuedit: false, // แก้วันเกิด
      selectbirthDate: new Date().toISOString().substr(0, 10) // เลือกวันเกิด
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
    EventBus.$on('addPosition', this.addPosition)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
    EventBus.$off('addPosition')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsitems = this.$route.params.id
    this.propsitemsTab = this.$route.params.tab
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      await this.getCenterManageEmployee()
      await this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
    }
  },
  computed: {
    checkCompany () {
      return !!this.selectGroupCompany.length
    },
    hasError () {
      return this.nameError.length > 0
    }
  },
  watch: {},
  methods: {
    changeProfile (data) {
      this.editProfile = true
    },
    async syncEditProfile () {
      const obj = {
        accountId: this.accountId
      }
      try {
        const res = await updateUserOneData(obj, this.$store.state.token)
        if (res.success) {
          this.text = 'คุณได้ทำการอัปเดตข้อมูลเรียบร้อยแล้ว'
          this.snackbar = true
          this.snackbarColor = 'success'
          this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.loading = false
      } finally {
        this.loadingEmployeeData = false
      }
    },
    async saveEditProfile () {
      const isValid = this.$refs.editProfileForm.validate()
      if (!isValid) {
        return
      }
      this.editProfile = false
      const obj = {
        _id: this.userId,
        nameEn: this.editfnameEN,
        nameTh: this.editfnameTH,
        nickNameTh: this.editnickNameTH,
        nickNameEn: this.editnickNameEN,
        birthday: this.selectbirthDate,
        tel: this.edittel,
        emailOneId: this.editemail,
        bussiness_tel: this.edittelcompany,
        bussiness_email: this.editemailcompany
      }
      try {
        const res = await editEmployeeDetail(obj, this.$store.state.token)
        this.$refs.editProfileForm.resetValidation()
        if (res.success) {
          this.text = 'คุณได้ทำการแก้ไขข้อมูลเรียบร้อยแล้ว'
          this.snackbar = true
          this.snackbarColor = 'success'
          this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.loading = false
      } finally {
        this.loadingEmployeeData = false
      }
    },
    closeEditProfile () {
      this.editProfile = false
      this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
      this.$refs.editProfileForm.resetValidation()
    },
    // get รายชื่อบริษัท
    goBack () {
      this.$router.push('/manageemployee')
    },
    setOpenApprover (i, value, departmentId) {
      if (value === true) {
        this.dataEmployee[i].leaderApprove = 'ต้องการ'
        this.dataEmployee[i].expand = true
        this.setApprover(i, departmentId)
      } else {
        this.dataEmployee[i].leaderApprove = 'ไม่ต้องการ'
        this.dataEmployee[i].expand = false
        this.dataEmployee[i].approver = []
        // this.setApprover()
      }
    },
    setparentCompany (indexI, item) {
      this.dataEmployee.filter(r => {
        if (r.parentCompanyText === 'บริษัทหลัก') {
          return r
        }
      })
      // if (findparentCompanyText.length >= 0) {
      //   for (let index = 0; index < this.dataEmployee.length; index++) {
      //     this.dataEmployee[index].parentCompanyText = 'บริษัทรอง'
      //     console.log(this.dataEmployee[index].parentCompanyText)
      //   }
      //   this.dataEmployee[indexI].parentCompanyText = 'บริษัทหลัก'
      // }
    },
    async searchEmployee (value) {
      const self = this
      const obj = {
        keySearch: value
      }
      var tmpUserData = null
      // console.log(obj)
      try {
        const res = await searchSelectEmployee(obj, this.$store.state.token)
        // console.log('res employee', res)
        if (res.success) {
          swal('พบข้อมูล', 'กรุณาตรวจสอบข้อมูลพนักงาน', 'success', {
            button: false,
            timer: 3000
          })
          tmpUserData = res.result
          self.genderth_radios = tmpUserData.titleEn
          self.genderen_radios = tmpUserData.titleEn
          self.fnameTH = tmpUserData.firstNameTh
          self.lnameTH = tmpUserData.lastNameTh
          self.fnameEN = tmpUserData.firstNameEn
          self.lnameEN = tmpUserData.lastNameEn
          self.accountId = tmpUserData.accountId
          self.birthDate = moment(tmpUserData.birthday).format('DD/MM/YYYY')
          self.email = tmpUserData.emailOneId
          self.userImg = tmpUserData.userImg
          if (self.userImg === '') {
            self.imageUrl = `${hostImageUrlv3}/_/${tmpUserData.emailOneId}`
          } else if (self.userImg === undefined) {
            self.imageUrl = null
          } else {
            self.imageUrl = `${hostImageUrlv3}/${tmpUserData.userImg}/${tmpUserData.emailOneId}`
          }
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          tmpUserData = null
          self.genderth_radios = ''
          self.genderen_radios = ''
          self.fnameTH = ''
          self.lnameTH = ''
          self.fnameEN = ''
          self.lnameEN = ''
          self.accountId = ''
          self.birthDate = moment(
            new Date().toISOString().substr(0, 10)
          ).format('DD/MM/YYYY')
          self.email = ''
        }
      } catch (error) {
        // console.log(error)
        swal('ไม่พบข้อมูล', 'กรุณาตรวจสอบ Username หรือ E-mail', 'warning', {
          button: false,
          timer: 3000
        })
        tmpUserData = null
        self.genderth_radios = ''
        self.genderen_radios = ''
        self.fnameTH = ''
        self.lnameTH = ''
        self.fnameEN = ''
        self.lnameEN = ''
        self.accountId = ''
        self.birthDate = moment(new Date().toISOString().substr(0, 10)).format(
          'DD/MM/YYYY'
        )
        self.email = ''
      }
    },
    openDialogAddPosition (companyId, indexI) {
      if (
        this.dataEmployee[indexI].companyId === '' ||
        this.dataEmployee[indexI].companyId === undefined
      ) {
        swal(
          'คำเตือน',
          'กรุณาเลือกบริษัทก่อนถึงจะสามารถเพิ่มตำแหน่งงานได้',
          'warning',
          {
            button: true
          }
        )
      } else {
        var nameCompany = ''
        this.dataEmployee[indexI].companyItems.map(data => {
          if (companyId === data._id) {
            nameCompany = data.companyFullNameTh
          }
        })
        EventBus.$emit(
          'openDialogAddPosition',
          true,
          companyId,
          nameCompany,
          // this.dataEmployee[indexI].companyId,
          indexI
        )
      }
    },
    gotoProfile () {
      const self = this
      self.activeTab = 1
      // console.log(self.activeTab)
    },
    gotoWorkData () {
      const self = this
      if (self.activeTab === 1) {
        if (
          self.genderth_radios &&
          self.fnameTH &&
          self.lnameTH &&
          self.genderen_radios &&
          self.fnameEN &&
          self.lnameEN &&
          self.accountId &&
          self.birthDate &&
          self.email
        ) {
          if (self.imageUrl) {
            self.activeTab = 2
          } else {
            swal('คำเตือน', 'กรุณาเลือกรูปประจำตัว', 'warning', {
              button: false,
              timer: 3000
            })
          }
        } else {
          swal('คำเตือน', 'กรุณาระบุประวัติพนักงาน', 'warning', {
            button: false,
            timer: 3000
          })
        }
      } else {
        self.activeTab = 2
      }
    },
    gotoRecheck () {
      const self = this
      if (self.activeTab === 1) {
        self.gotoWorkData()
      } else if (self.activeTab === 2) {
        if (
          self.companyId &&
          self.employeeId &&
          self.lineofworkId &&
          self.departmentId &&
          self.positionId &&
          self.startWorkDate
        ) {
          self.activeTab = 3
        } else {
          swal('คำเตือน', 'กรุณาระบุข้อมูลพนักงาน', 'warning', {
            button: false,
            timer: 3000
          })
        }
      }
    },
    // selectType (event, i) {
    //   console.log(event)
    //   if (event === 'พนักงานภายนอก') {
    //     this.dataEmployee[i].employeeId = ''
    //   }
    //   this.manage_linear(i)
    // },
    manage_linear (i) {
      if (this.dataEmployee[i].typeText === 'พนักงานภายใน') {
        var idNumber = 30
        var linework = 30
        var position = 40
        if (
          this.dataEmployee[i].employeeId === '' ||
          this.dataEmployee[i].employeeId === null
        ) {
          idNumber = 0
        }
        if (
          this.dataEmployee[i].lineofworkId === '' ||
          this.dataEmployee[i].lineofworkId === null ||
          this.dataEmployee[i].lineofworkId === undefined ||
          this.dataEmployee[i].lineofworkId === 'ไม่มี'
        ) {
          linework = 0
        }
        if (
          this.dataEmployee[i].positionId === '' ||
          this.dataEmployee[i].positionId === null ||
          this.dataEmployee[i].positionId === undefined ||
          this.dataEmployee[i].positionId === 'ไม่มี'
        ) {
          position = 0
        }
        this.level_bar[i] =
          Number(idNumber) + Number(linework) + Number(position)
      } else if (this.dataEmployee[i].typeText === 'พนักงานภายนอก') {
        var linework2 = 50
        var position2 = 50
        if (
          this.dataEmployee[i].lineofworkId === '' ||
          this.dataEmployee[i].lineofworkId === null ||
          this.dataEmployee[i].lineofworkId === undefined ||
          this.dataEmployee[i].lineofworkId === 'ไม่มี'
        ) {
          linework2 = 0
        }
        if (
          this.dataEmployee[i].positionId === '' ||
          this.dataEmployee[i].positionId === null ||
          this.dataEmployee[i].positionId === undefined ||
          this.dataEmployee[i].positionId === 'ไม่มี'
        ) {
          position2 = 0
        }
        this.level_bar[i] = Number(linework2) + Number(position2)
      }
    },
    async getEmployeeDetail (id, tab) {
      // const temp = []
      this.level_bar = []
      let urlEmp = ''
      if (tab === 'employee') {
        urlEmp = `${this.api}/api/vMonk/manageEmployee/getUserData/`
      } else if (tab === 'employeeResign') {
        urlEmp = `${this.api}/api/vMonk/manageEmployee/getResignUserDetail/`
      }
      await this.axios({
        method: 'get',
        url: urlEmp + id
      })
        .then(response => {
          this.employeeData = response.data.result.history
          // this.desserts = response.data.result
          if (response.data.success) {
            this.fnameTH = response.data.result.NameTh
            this.editfnameTH = response.data.result.NameTh // แก้ไขชื่อไทย
            this.fnameEN = response.data.result.NameEn
            this.editfnameEN = response.data.result.NameEn // แก้ไขชื่ออังกฤษ
            this.nickName = response.data.result.nickName
            this.editnickNameTH = response.data.result.nickName // แก้ไขชื่อเล่น
            this.nickNameEn = response.data.result.nickNameEn
            this.editnickNameEN = response.data.result.nickNameEn // แก้ไขชื่อเล่นอังกฤษ
            this.birthDate = moment(response.data.result.birthday).format('DD/MM/YYYY')
            this.selectbirthDate = this.formatWorkDate(response.data.result.birthday) // แก้ไขวันเกิด
            this.email = response.data.result.emailOneId
            this.editemail = response.data.result.emailOneId // แก้ไขอีเมล
            this.tel = response.data.result.tel
            this.edittel = response.data.result.tel // แก้ไขเบอร์โทร
            this.accountId = response.data.result.accountId
            this.emailcompany = response.data.result.bussiness_email // อีเมลบริษัท
            this.editemailcompany = response.data.result.bussiness_email // edit อีเมลบริษัท
            this.telcompany = response.data.result.bussiness_tel // เบอร์บริษัท
            this.edittelcompany = response.data.result.bussiness_tel // edit เบอร์บริษัท
            this.userImg = response.data.result.userImg
            this.userId = response.data.result._id
            if (this.userImg === '') {
              this.imageUrl = `${hostImageUrlv3}/_/${response.data.result.emailOneId}`
            } else if (this.userImg === undefined) {
              this.imageUrl = null
            } else {
              this.imageUrl = `${hostImageUrlv3}/${response.data.result.userImg}/${response.data.result.emailOneId}`
            }
            this.dataEmployee = response.data.result.dataEmployee
            for (let index = 0; index < this.dataEmployee.length; index++) {
              this.dataEmployee[index].contractType = this.validContractType.includes(this.dataEmployee[index].contractType) ? this.dataEmployee[index].contractType : 'พนักงานชั่วคราว'
              this.level_bar.push(0)
            }
            for (let index = 0; index < this.dataEmployee.length; index++) {
              this.manage_linear(index)
            }
            this.dataEmployee.map((el, index) => {
              if (el.endWorkDate !== '') {
                el.endWorkDate = this.formatWorkDate(el.endWorkDate)
              }
              if (el.startWorkDate !== '') {
                el.startWorkDate = this.formatWorkDate(el.startWorkDate)
              }
              if (el.lastWorkDate !== '') {
                el.lastWorkDate = this.formatWorkDate(el.lastWorkDate)
              }
            })
            for (let i = 0; i < this.dataEmployee.length; i++) {
              this.$nextTick(() => {
                // this.getSelectCompany(this.dataEmployee[i].companyId, '')
                this.getSelectLineofworkDetail(
                  i,
                  this.dataEmployee[i].companyId,
                  this.dataEmployee[i].positionId
                )
              })
              this.loading = false
            }
          }
          if (tab === 'employee') {
            this.valid = true
          } else {
            this.valid = false
          }
        })
        .catch(e => {
          this.loading = false
          console.log(e)
        })
    },
    async getCenterManageEmployee () {
      try {
        const res = await SelectDataCenterinEditOfficer()
        if (res.success) {
          this.stationList = res.selector.station
          this.employeeTypeList = res.selector.contractType
          this.validContractType = res.selector.contractType.map(({ type }) => type)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getSelectCompany (index, value) {
      this.loadingProfileData = true
      this.dataEmployee[index].companyItems = [] // รายชื่อบริษัท
      var objnull = {
        companyId: '',
        companyName: value,
        orgChartName: '',
        positionName: ''
      }
      try {
        // const res = await getSelectCompanyEmployee(self.$store.state.token) // เก่า
        const res = await getSelectCompanyEmployeeNew(
          objnull,
          this.$store.state.token
        ) // ใหม่
        if (res.success) {
          this.dataEmployee[index].companyItems = res.companys
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingProfileData = false
      }
    },
    // พิมพ์ค้นหาแผนกและตำแหน่ง
    async getSelect (value, keyname, i, companyId) {
      var datafilterall = ''
      if (keyname === 'แผนก') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: value,
          positionName: ''
        }
        datafilterall = obj
      } else if (keyname === 'ตำแหน่ง') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: '',
          positionName: value
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectCompanyEmployeeNew(
          datafilterall,
          this.$store.state.token
        ) // ใหม่
        if (res.success) {
          if (keyname === 'แผนก') {
            this.dataEmployee[i].departmentItems = res.orgchart // แผนก
            this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          } else if (keyname === 'ตำแหน่ง') {
            this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getSelectLineofworkDetail (i, cid, pid) {
      const obj = {
        companyId: cid,
        companyName: '',
        orgChartName: '',
        positionName: '',
        positionId: pid
      }
      try {
        const res = await getSelectCompanyEmployeeNew(
          obj,
          this.$store.state.token
        ) // ใหม่
        if (res.success) {
          this.companyItems = res.companys
          this.dataEmployee[i].companyItems = res.companys // บริษัท
          this.dataEmployee.splice(0, 0)
          this.dataEmployee[i].departmentItems = res.orgchart // แผนก
          this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          this.loading = false
          // this.isload = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    // ฟังก์ชันข้อมูลตัวเลือกสายงานต่างๆ
    // async getSelectLineofwork (i, id) {
    //   // console.log('ID success Company', id)
    //   this.loading = true
    //   const self = this
    //   const objOrgChart = {
    //     groupId: self.dataEmployee[i].groupId,
    //     agencyId: self.dataEmployee[i].agencyId,
    //     sectionId: self.dataEmployee[i].sectionId,
    //     departmentId: self.dataEmployee[i].departmentId,
    //     lineofworkId: self.dataEmployee[i].lineofworkId
    //   }
    //   const obj = {
    //     // companyId: self.companyId
    //     companyId: id,
    //     objOrgChart: objOrgChart
    //   }
    //   self.dataEmployee[i].lineofworkDisable = false
    //   self.dataEmployee[i].departmentDisable = false
    //   self.dataEmployee[i].sectionDisable = false
    //   self.dataEmployee[i].groupDisable = false
    //   self.dataEmployee[i].agencyDisable = false
    //   this.dataEmployee[i].lineofworkId = 'ไม่มี'
    //   self.dataEmployee[i].departmentId = 'ไม่มี'
    //   self.dataEmployee[i].sectionId = 'ไม่มี'
    //   self.dataEmployee[i].groupId = 'ไม่มี'
    //   self.dataEmployee[i].agencyId = 'ไม่มี'
    //   self.dataEmployee[i].positionId = 'ไม่มี'

    //   self.dataEmployee[i].lineofworkItems = []
    //   self.dataEmployee[i].departmentItems = []
    //   self.dataEmployee[i].sectionItems = []
    //   self.dataEmployee[i].groupItems = []
    //   self.dataEmployee[i].agencyItems = []
    //   self.dataEmployee[i].positionItems = []
    //   this.loading = true
    //   try {
    //     const res = await checkOrgChartInCompany(obj, self.$store.state.token)
    //     // console.log('Check Orgchart', res.result)
    //     if (res.success) {
    //       self.dataEmployee[i].lineofworkItems =
    //         res.result.orgChart[0].list.length !== 0
    //           ? res.result.orgChart[0].list
    //           : self.itemDefault
    //       self.dataEmployee[i].departmentItems =
    //         res.result.orgChart[1].list.length !== 0
    //           ? res.result.orgChart[1].list
    //           : self.itemDefault
    //       self.dataEmployee[i].sectionItems =
    //         res.result.orgChart[2].list.length !== 0
    //           ? res.result.orgChart[2].list
    //           : self.itemDefault
    //       self.dataEmployee[i].agencyItems =
    //         res.result.orgChart[3].list.length !== 0
    //           ? res.result.orgChart[4].list
    //           : self.itemDefault
    //       self.dataEmployee[i].groupItems =
    //         res.result.orgChart[4].list.length !== 0
    //           ? res.result.orgChart[3].list
    //           : self.itemDefault
    //       self.dataEmployee[i].positionItems = res.result.position
    //       self.dataEmployee[i].lineofworkStatus = res.result.orgChart[0].status
    //       self.dataEmployee[i].departmentStatus = res.result.orgChart[1].status
    //       self.dataEmployee[i].sectionStatus = res.result.orgChart[2].status
    //       self.dataEmployee[i].groupStatus = res.result.orgChart[3].status
    //       self.dataEmployee[i].agencyStatus = res.result.orgChart[4].status
    //       // set disable
    //       self.dataEmployee[i].lineofworkDisable =
    //         res.result.orgChart[0].status
    //       self.dataEmployee[i].departmentDisable =
    //         res.result.orgChart[1].status
    //       self.dataEmployee[i].sectionDisable = res.result.orgChart[2].status
    //       self.dataEmployee[i].agencyDisable = res.result.orgChart[3].status
    //       self.dataEmployee[i].groupDisable = res.result.orgChart[4].status
    //       this.loading = false
    //     } else {
    //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //         button: false,
    //         timer: 2000
    //       })
    //       this.loading = false
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //       button: false,
    //       timer: 2000
    //     })
    //     this.loading = false
    //   }
    // },
    // async getDataListOrgChart (i, id, companyId, type) {
    //   this.loading = true
    //   const self = this
    //   var temp = []
    //   const obj = {
    //     _id: id,
    //     companyId: companyId
    //   }
    //   try {
    //     const res = await getListOrgChart(obj, self.$store.state.token)
    //     if (res.result.length === 0) {
    //       temp.unshift({
    //         _id: 'ไม่มี',
    //         orgChartName: 'ไม่มี'
    //       })
    //     } else {
    //       temp = res.result
    //     }
    //     if (res.success) {
    //       if (type === 'สายงาน') {
    //         if (self.dataEmployee[i].lineofworkId !== '') {
    //           self.dataEmployee[i].departmentId = 'ไม่มี'
    //           self.dataEmployee[i].sectionId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].departmentItems = self.itemDefault
    //           self.dataEmployee[i].sectionItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].departmentStatus = false
    //           self.dataEmployee[i].sectionStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           self.dataEmployee[i].agencyStatus = false
    //           if (self.dataEmployee[i].lineofworkStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].departmentItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].departmentId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].departmentItems = res.result
    //               self.dataEmployee[i].departmentItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].departmentDisable = true
    //             self.dataEmployee[i].departmentStatus = true
    //             // self.dataEmployee[i].departmentStatus = true
    //           } else {
    //             self.dataEmployee[i].departmentDisable = false
    //             self.dataEmployee[i].departmentStatus = false
    //           }
    //         }
    //       } else if (type === 'ฝ่ายงาน') {
    //         if (self.dataEmployee[i].departmentId !== '') {
    //           self.dataEmployee[i].sectionId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].sectionItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].sectionStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           self.dataEmployee[i].agencyStatus = false
    //           if (self.dataEmployee[i].departmentStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].sectionItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].sectionId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].sectionItems = res.result
    //               self.dataEmployee[i].sectionItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].sectionDisable = true
    //             self.dataEmployee[i].sectionStatus = true
    //             // self.dataEmployee[i].departmentStatus = true
    //           } else {
    //             self.dataEmployee[i].sectionDisable = false
    //             self.dataEmployee[i].sectionStatus = false
    //           }
    //         }
    //       } else if (type === 'ส่วนงาน') {
    //         if (self.dataEmployee[i].sectionId !== '') {
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           if (self.dataEmployee[i].sectionStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].agencyItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].agencyId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].agencyItems = res.result
    //               self.dataEmployee[i].agencyItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].agencyDisable = true
    //             self.dataEmployee[i].agencyStatus = true
    //             // self.dataEmployee[i].departmentStatus = true
    //           } else {
    //             self.dataEmployee[i].agencyDisable = false
    //             self.dataEmployee[i].agencyStatus = false
    //           }
    //         }
    //       } else if (type === 'หน่วยงาน') {
    //         if (self.dataEmployee[i].agencyId !== '') {
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].groupStatus = false
    //           if (self.dataEmployee[i].agencyStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].groupItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].groupId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].groupItems = res.result
    //               self.dataEmployee[i].groupItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].groupDisable = true
    //             self.dataEmployee[i].groupStatus = true
    //             // self.dataEmployee[i].departmentStatus = true
    //           } else {
    //             self.dataEmployee[i].groupDisable = false
    //             self.dataEmployee[i].groupStatus = false
    //           }
    //         }
    //       } else if (type === 'กลุ่มงาน') {
    //         if (self.dataEmployee[i].gruopId !== '') {
    //           if (self.dataEmployee[i].groupStatus === true) {
    //             self.dataEmployee[i].positionDisable = true
    //             self.dataEmployee[i].positionStatus = true
    //           }
    //         }
    //       }
    //       this.loading = false
    //     } else {
    //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //         button: false,
    //         timer: 2000
    //       })
    //       this.loading = false
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //       button: false,
    //       timer: 2000
    //     })
    //     this.loading = false
    //   }
    // },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name
        .substr(dotindex + 1)
        .toLowerCase()
      if (
        FileExtension === 'jpg' ||
        FileExtension === 'png' ||
        FileExtension === 'JPG' ||
        FileExtension === 'PNG'
      ) {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var imgUser = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          imgUser.src = evt.target.result
        }
      }
    },
    async setApprover (i, departmentId) {
      this.loading = true
      this.selectData = []
      const obj = {
        orgChartId: departmentId
      }
      try {
        const res = await getDefaultApprover(obj, this.$store.state.token)
        if (res.success) {
          if (res.result.length) {
            var imageUrlDefault = ''
            if (res.result[0].userImg === '') {
              imageUrlDefault = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
            } else {
              imageUrlDefault = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
            }
            this.dataEmployee[i].approver = [
              {
                no: 1,
                _id: res.result[0]._id,
                employeeId: res.result[0].employeeId,
                approverName: res.result[0].approverName,
                position: res.result[0].positionId,
                email: res.result[0].email,
                approveType: 'ผู้อนุมัติ',
                userImg: imageUrlDefault
              }
            ]
          }
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    openDialogAddAprover (action, item, index, indexJ) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index, indexJ)
    },
    addEmployee () {
      this.dataEmployee.push({
        companyId: '',
        parentCompanyText: 'บริษัทรอง',
        typeText: '',
        menuResign: false,
        menu: false,
        menu2: false,
        dateResign: new Date().toISOString().substr(0, 10),
        startWorkDate: new Date().toISOString().substr(0, 10),
        endWorkDate: '',
        contractType: '',
        station: '',
        rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
        lineofworkStatus: false,
        lineofworkDisable: false,
        lineofworkId: '',
        lineofworkItems: [],
        rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
        departmentStatus: false,
        departmentDisable: false,
        departmentId: '',
        departmentItems: [],
        companyItems: this.companyItems,
        rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
        sectionStatus: false,
        sectionDisable: false,
        sectionId: '',
        sectionItems: [],
        rulesSection: [v => !!v || 'กรุณาเลือกส่วนงาน'],
        groupStatus: false,
        groupDisable: false,
        groupId: '',
        groupItems: [],
        rulesGroup: [v => !!v || 'กรุณาเลือกกลุ่มงาน'],
        agencyStatus: false,
        agencyDisable: false,
        agencyId: '',
        agencyItems: [],
        rulesAgency: [v => !!v || 'กรุณาเลือกหน่วยงาน'],
        positionStatus: false,
        positionDisable: true,
        positionId: '',
        positionItems: [],
        rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
        employeeId: '',
        chkLeaderApprove: false,
        leaderApprove: 'ไม่ต้องการ',
        resign: false,
        approver: [],
        orgchart: ''
      })
      this.text = 'เพิ่มข้อมูลพนักงาน'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    addPosition (item, indexI) {
      var temp = JSON.parse(JSON.stringify(this.dataEmployee))
      temp[indexI].positionItems.unshift({
        _id: item[0]._id,
        positionName: item[0].positionName
      })
      this.dataEmployee = JSON.parse(JSON.stringify(temp))
    },
    add (value, index, action, indexJ) {
      var filterValue = this.dataEmployee[index].approver.filter(r => {
        // if (
        //   r.position === value.position &&
        //   r.employeeId === value.employeeId
        // ) {
        if (r.emailOneId === value.email && r.employeeId === value.employeeId) {
          return r
        }
      })
      if (action === 'add') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.dataEmployee[index].approver.push({
            approverNo: this.dataEmployee[index].approver.length + 1,
            _id: value.id,
            employeeId: value.employeeId,
            approverName: value.name,
            // position: value.position,
            email: value.email,
            userImg: value.userImg,
            approveType: value.approveType,
            failed_image: false
          })
        }
      } else if (action === 'edit') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.dataEmployee[index].approver[indexJ].approverNo = index + 1
          this.dataEmployee[index].approver[indexJ]._id = value.id
          this.dataEmployee[index].approver[indexJ].employeeId =
            value.employeeId
          this.dataEmployee[index].approver[indexJ].approverName = value.name
          // this.dataEmployee[index].approver[indexJ].position = value.position
          this.dataEmployee[index].approver[indexJ].email = value.email
          this.dataEmployee[index].approver[indexJ].approveType =
            value.approveType
          this.dataEmployee[index].approver[indexJ].userImg = value.userImg
          this.dataEmployee[index].approver[indexJ].failed_image =
            value.failed_image || false
        }
      }
    },
    remove (index) {
      this.positionData.splice(index, 1)
    },
    checkRemove (item, index) {
      this.itemConfirmDelete = []
      this.itemIndex = 0
      this.itemConfirmDelete = item
      this.itemIndex = index
      this.dialogDeleteApprover = true
    },
    removeApprover (item, index) {
      // console.log('removeApprover', this.approver.indexOf(item))
      this.dataEmployee[this.itemIndex].approver.splice(
        this.dataEmployee[this.itemIndex].approver.indexOf(item),
        1
      )
      this.itemConfirmDelete = []
      this.itemIndex = 0
      this.dialogDeleteApprover = false
      this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    checkRemoveEmployee (item) {
      this.itemConfirmDelete = []
      this.itemConfirmDelete = item
      this.dialogDelete = true
    },
    removeEmployee (item) {
      // console.log('removeApprover', this.approver.indexOf(item))
      this.dataEmployee.splice(this.dataEmployee.indexOf(item), 1)
      this.itemConfirmDelete = []
      this.dialogDelete = false
      this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
      for (let index = 0; index < this.dataEmployee.length; index++) {
        this.level_bar.push(0)
      }
      for (let index = 0; index < this.dataEmployee.length; index++) {
        this.manage_linear(index)
      }
    },
    checkSubmit () {
      var checkValue = this.dataEmployee.filter((r, index) => {
        var valueIndex = index + 1
        if (r.typeText === 'พนักงานภายใน' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'พนักงานภายนอก' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'ที่ปรึกษา' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'นักศึกษาฝึกงาน' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.companyId === '') {
          // console.log('null')
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกบริษัท',
            'warning'
          )
          return r
        }
        if (r.orgchart === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกแผนก',
            'warning'
          )
          return r
        }
        if (r.lineofworkStatus === true && r.lineofworkId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกสายงาน',
            'warning'
          )
          return r
        }
        if (r.departmentStatus === true && r.departmentId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกฝ่ายงาน',
            'warning'
          )
          return r
        }
        if (r.sectionStatus === true && r.sectionId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกส่วนงาน',
            'warning'
          )
          return r
        }
        if (r.agencyStatus === true && r.agencyId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกหน่วยงาน',
            'warning'
          )
          return r
        }
        if (r.groupStatus === true && r.groupId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกกลุ่มงาน',
            'warning'
          )
          return r
        }
        if (r.positionId === '' || r.positionId === 'ไม่มี') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกตำแหน่งงาน',
            'warning'
          )
          return r
        }
        if (r.resign === true && r.endWorkDate === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' +
              valueIndex +
              ' กรุณาเลือกวันลาออกมีผลบังคับใช้เมื่อ',
            'warning'
          )
          return r
        }
      })
      if (checkValue.length === 0) {
        this.submitData()
      }
    },
    async submitData () {
      this.loading = true
      this.loadingEmployeeData = true
      var formData = new FormData()
      formData.append('username', this.email)
      formData.append('userId', this.userId)
      formData.append('dataEmployee', JSON.stringify(this.dataEmployee))
      if (this?.files?.length) formData.append('image', this.files[0])
      else if (this.imagePathUrl) formData.append('image', '')
      const obj = formData
      try {
        const res = await editEmployee(obj, this.$store.state.token)
        if (res.success) {
          this.text = 'คุณได้ทำการแก้ไขข้อมูลเรียบร้อยแล้ว'
          this.snackbar = true
          this.snackbarColor = 'success'
          swal('สำเร็จ', 'แก้ไขพนักงานสำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          this.keySearchEmployee = ''
          this.companyId = ''
          this.employeeId = ''
          this.departmentId = ''
          this.positionId = ''
          this.files = []
          this.loadingEmployeeData = false
          this.$router.go(-1)
        } else {
          swal(
            'ผิดพลาด',
            `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`,
            'error'
          )
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.loading = false
      } finally {
        this.loadingEmployeeData = false
      }
    },
    onImgError (i, j) {
      this.dataEmployee[i].approver[j].failed_image = true
    },
    onImgErrorEmployee (i) {
      // this.approver[i].failed_image = true
    },
    formatWorkDate (date) {
      return date ? moment(date).format('yyyy-MM-DD') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatBirthDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    cancel () {
      // swal('คำเตือน', 'ข้อมูลของพนักงานจะถูกรีเซ็ต', 'warning', {
      //   dangerMode: true,
      //   buttons: true
      // }).then((willDelete) => {
      //   if (willDelete) {
      //     swal('คำเตือน', 'ข้อมูลของพนักงานถูกรีเซ็ตเรียบร้อยแล้ว', 'warning', {
      //       buttons: false,
      //       timer: 3000
      //     }).then(() => this.$router.go(-1))
      //   } else {
      //     swal('คำเตือน', 'ข้อมูลของพนักงานยังไม่ถูกรีเซ็ต', 'warning', {
      //       buttons: false,
      //       timer: 3000
      //     })
      //   }
      // })
      this.$router.go(-1)
    },
    goLogin () {
      this.loading = true
      setTimeout(() => {
        this.$store.commit('clearToken')
        this.$store.commit('clearUser')
        this.loading = false
        this.$router.push('/login')
      }, 2000)
    }
  }
}
</script>

<style scoped>
@import "../../../css/CreateEmployee.css";

.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1),
table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #f8f9fb;
}

.v-stepper {
  box-shadow: none !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
.v-application {
  padding: 0 !important;
}
.maminus-5 {
  margin: 0 -20px !important;
}
.v-stepper__step {
  flex-direction: column !important;
}
.v-application--is-ltr .v-stepper__step__step {
  margin-right: 0 !important;
}
.theme--light.v-divider {
  border-color: rgb(229, 230, 231) !important;
}
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  padding: 24px;
  position: relative;
}
.step-container:hover {
  cursor: pointer;
}
.step-container:hover .step-circle-inactive {
  /* border: 2px solid rgb(122, 212, 108) !important; */
  border: 2px solid #004682 !important;
}
.step-container:hover .step-circle-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-container:hover .step-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-circle-active {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  /* border: 2px solid rgb(103, 173, 92) !important; */
  border: 2px solid #07d1bf !important;
}
.step-circle-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-circle-inactive {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  border: 2px solid rgb(229, 230, 231) !important;
}
.step-circle-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.step-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.container-profile {
  border-radius: 15px;
  border: 1px solid rgb(229, 230, 231);
  background-color: #fff;
}
div.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
div.v-messages {
  min-height: 0 !important;
}
.txt-font-label {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 5px;
  color: #757575;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.ra-span-text-highlight {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Neutral / #333333 */

  color: #333333;
}
.ra-layout-empty {
  height: 640px;
  left: 32px;
  right: 32px;
  top: 164px;
}
.ra-head-text-bold {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #2ba197;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.ra-border-button {
  background: #ffffff;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: "Sarabun", sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.v-progress-linear {
  border-radius: 12px;
  margin: 0; /* remove margin as the txt will create that margin */
}
.progress-bar-txt {
  z-index: 1;
  position: absolute;
  right: 10px;
  color: white;
}
</style>
